<!-- Пункт бокового меню для отдельной страницы календаря автопарка. -->
<template>
  <li
    v-if="canSeePage('fleet')"
    class="nav-item calendar-nav-item"
    role="button"
    tabindex="0"
    :class="{ active: activeItem === 'calendar' }"
    :title="collapsed ? 'Календарь' : ''"
    @click="navigate($event, 'FleetCalendar')"
    @mouseup="handleMiddleClick($event, 'FleetCalendar')"
    @contextmenu.prevent.stop="showContextMenu($event, 'FleetCalendar')"
  >
    <div class="link-icon_box">
      <CalendarNavIcon :size="24" />
    </div>
    <AppSidebarItemLabel
      label="Календарь"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import CalendarNavIcon from "@/components/Icon/icons/CalendarNavIcon.vue";
import { sidebarItemProps } from "@/composables/useSidebarItem";

export default {
  name: "AppSidebarCalendarItem",

  components: {
    AppSidebarItemLabel,
    CalendarNavIcon,
  },

  props: sidebarItemProps,

  emits: ["navigate", "middle-click", "context-menu"],

  methods: {
    navigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    handleMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    showContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>
